define('CreditApplication.View', [
    'Backbone',
    'cti_credit_application_form.tpl',
    'CreditApplication.Model',
    'SignaturePad',
    'underscore',
    'jQuery'
], function (
    Backbone,
    cti_credit_application_form_tpl,
    CreditApplicationModel,
    SignaturePad,
    _,
    $
) {
    'use strict';

    return Backbone.View.extend({
        template: cti_credit_application_form_tpl,

        title: 'Credit Application for Net 30 Terms - CTI Connect',

        events: {
            'submit #cti-credit-application-form': 'saveForm',
            'click .btn-clear-signature': 'clearSignature',
            'change input, select': 'onFieldChange',
            'blur input[required], select[required]': 'onFieldBlur'
        },

        initialize: function (options) {
            this.application = options.application;
            this.model = new CreditApplicationModel();

            this.isSubmitting = false;
            this.showSuccess = false;
            this.errorMessage = '';
            this.recordId = null;

            this.authSignaturePad = null;
            this.termsSignaturePad = null;
        },

        render: function () {
            Backbone.View.prototype.render.apply(this, arguments);

            if (!this.showSuccess) {
                this.initSignaturePads();
            }

            return this;
        },

        initSignaturePads: function () {
            var self = this;

            this.authSignaturePad = null;
            this.termsSignaturePad = null;

            var authCanvas = this.$('#auth-signature-canvas')[0];
            var termsCanvas = this.$('#terms-signature-canvas')[0];

            if (authCanvas) {
                this.resizeCanvasElement(authCanvas);

                this.authSignaturePad = new SignaturePad(authCanvas, {
                    penColor: '#003366',
                    backgroundColor: '#ffffff'
                });
            } else {
                if (window.console) {
                    console.error(
                        'Credit Application: auth-signature-canvas was not found.'
                    );
                }
            }

            if (termsCanvas) {
                this.resizeCanvasElement(termsCanvas);

                this.termsSignaturePad = new SignaturePad(termsCanvas, {
                    penColor: '#003366',
                    backgroundColor: '#ffffff'
                });
            } else {
                if (window.console) {
                    console.error(
                        'Credit Application: terms-signature-canvas was not found.'
                    );
                }
            }

            $(window)
                .off('resize.creditAppSig')
                .on(
                    'resize.creditAppSig',
                    _.debounce(function () {

                        if (authCanvas) {
                            self.preserveAndResizeSignature(
                                authCanvas,
                                self.authSignaturePad
                            );
                        }

                        if (termsCanvas) {
                            self.preserveAndResizeSignature(
                                termsCanvas,
                                self.termsSignaturePad
                            );
                        }

                    }, 250)
                );
        },

        resizeCanvasElement: function (canvas) {
            if (!canvas) {
                return;
            }

            var ratio = Math.max(
                window.devicePixelRatio || 1,
                1
            );

            var width =
                canvas.offsetWidth ||
                canvas.clientWidth ||
                400;

            var height =
                canvas.offsetHeight ||
                canvas.clientHeight ||
                180;

            canvas.width = width * ratio;
            canvas.height = height * ratio;

            var context = canvas.getContext('2d');

            context.scale(ratio, ratio);
        },

        preserveAndResizeSignature: function (
            canvas,
            signaturePad
        ) {
            if (!canvas || !signaturePad) {
                return;
            }

            var signatureData = null;

            if (!signaturePad.isEmpty()) {
                signatureData = signaturePad.toData();
            }

            this.resizeCanvasElement(canvas);

            signaturePad.clear();

            if (
                signatureData &&
                signatureData.length
            ) {
                signaturePad.fromData(signatureData);
            }
        },

        clearSignature: function (e) {
            e.preventDefault();

            var target =
                $(e.currentTarget).data('target');

            if (
                target === 'auth' &&
                this.authSignaturePad
            ) {
                this.authSignaturePad.clear();

                this.$('#authSignature').val('');

                this.$(
                    '[data-validation-error="authSignature"]'
                ).text('');

            } else if (
                target === 'terms' &&
                this.termsSignaturePad
            ) {
                this.termsSignaturePad.clear();

                this.$('#termsSignature').val('');

                this.$(
                    '[data-validation-error="termsSignature"]'
                ).text('');
            }
        },

        onFieldChange: function (e) {
            var $field = $(e.currentTarget);
            var name = $field.attr('name');

            if (name) {
                this.$(
                    '[data-validation-error="' +
                    name +
                    '"]'
                ).text('');
            }
        },

        onFieldBlur: function (e) {
            var $field = $(e.currentTarget);
            var name = $field.attr('name');
            var val = $.trim($field.val());

            if (
                $field.prop('required') &&
                !val
            ) {
                this.$(
                    '[data-validation-error="' +
                    name +
                    '"]'
                ).text('This field is required.');
            }
        },

        getSignatureData: function (
            signaturePad,
            hiddenFieldSelector
        ) {
            if (
                signaturePad &&
                !signaturePad.isEmpty()
            ) {
                return signaturePad.toDataURL(
                    'image/png'
                );
            }

            /*
             * Hidden input fallback.
             *
             * This also makes debugging easier and
             * protects against re-render situations.
             */
            var hiddenValue =
                $.trim(
                    this.$(
                        hiddenFieldSelector
                    ).val() || ''
                );

            return hiddenValue;
        },

        validateClientForm: function (data) {
            var errors = {};

            var emailRegex =
                /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (!data.companyName) {
                errors.companyName =
                    'Company Name is required.';
            }

            if (!data.phoneNumber) {
                errors.phoneNumber =
                    'Phone Number is required.';
            }

            if (!data.email) {
                errors.email =
                    'E-mail is required.';
            } else if (
                !emailRegex.test(data.email)
            ) {
                errors.email =
                    'Please enter a valid email address.';
            }

            if (!data.shipAddr1) {
                errors.shipAddr1 =
                    'Street Address is required.';
            }

            if (!data.shipCity) {
                errors.shipCity =
                    'City is required.';
            }

            if (!data.shipState) {
                errors.shipState =
                    'State / Province is required.';
            }

            if (!data.shipPostal) {
                errors.shipPostal =
                    'Postal / Zip Code is required.';
            }

            if (!data.shipCountry) {
                errors.shipCountry =
                    'Country is required.';
            }

            if (!data.companyType) {
                errors.companyType =
                    'Company Type is required.';
            }

            if (!data.apFirstName) {
                errors.apFirstName =
                    'First Name is required.';
            }

            if (!data.apLastName) {
                errors.apLastName =
                    'Last Name is required.';
            }

            if (!data.apPhone) {
                errors.apPhone =
                    'Accounts Payable Phone is required.';
            }

            if (!data.apEmail) {
                errors.apEmail =
                    'Accounts Payable E-mail is required.';
            } else if (
                !emailRegex.test(data.apEmail)
            ) {
                errors.apEmail =
                    'Please enter a valid email address.';
            }

            if (!data.billAddr1) {
                errors.billAddr1 =
                    'Street Address is required.';
            }

            if (!data.billCity) {
                errors.billCity =
                    'City is required.';
            }

            if (!data.billState) {
                errors.billState =
                    'State / Province is required.';
            }

            if (!data.billCountry) {
                errors.billCountry =
                    'Country is required.';
            }

            if (!data.billPostal) {
                errors.billPostal =
                    'Postal / Zip Code is required.';
            }

            if (!data.bankName) {
                errors.bankName =
                    'Bank Name is required.';
            }

            if (!data.bankBranchName) {
                errors.bankBranchName =
                    'Branch Name is required.';
            }

            if (!data.bankPhone) {
                errors.bankPhone =
                    'Bank Branch Phone Number is required.';
            }

            if (!data.bankAddr1) {
                errors.bankAddr1 =
                    'Bank Street Address is required.';
            }

            if (!data.bankCity) {
                errors.bankCity =
                    'City is required.';
            }

            if (!data.bankState) {
                errors.bankState =
                    'State / Province is required.';
            }

            if (!data.bankCountry) {
                errors.bankCountry =
                    'Country is required.';
            }

            if (!data.bankPostal) {
                errors.bankPostal =
                    'Bank Postal / Zip Code is required.';
            }

            if (!data.fedTaxId) {
                errors.fedTaxId =
                    'Federal Tax ID # is required.';
            }

            if (!data.creditRequested) {
                errors.creditRequested =
                    'Amount of Credit requested is required.';
            }

            if (!data.poRequired) {
                errors.poRequired =
                    'Please indicate if POs are required.';
            }

            if (!data.checkingAcctNum) {
                errors.checkingAcctNum =
                    'Checking Acct. # is required.';
            }

            if (!data.checkingRoutingNum) {
                errors.checkingRoutingNum =
                    'Checking Routing # is required.';
            }

            if (!data.savingsAcctNum) {
                errors.savingsAcctNum =
                    'Savings Acct. # is required.';
            }

            if (!data.savingsRoutingNum) {
                errors.savingsRoutingNum =
                    'Savings Routing # is required.';
            }

            if (!data.authReleaseInfo) {
                errors.authReleaseInfo =
                    'Authorization to release confidential information is required.';
            }

            /*
             * IMPORTANT FIX:
             *
             * Validate actual Base64 payload instead
             * of only checking whether the pad object
             * happens to exist.
             */
            if (!data.authSignature) {
                errors.authSignature =
                    'Authorization Signature is required. Please draw your signature.';
            }

            if (!data.ref1CompanyName) {
                errors.ref1CompanyName =
                    'Reference 1 Company Name is required.';
            }

            if (!data.ref1ContactName) {
                errors.ref1ContactName =
                    'Reference 1 Contact Name is required.';
            }

            if (!data.ref1Phone) {
                errors.ref1Phone =
                    'Reference 1 Phone Number is required.';
            }

            if (!data.ref1Addr1) {
                errors.ref1Addr1 =
                    'Reference 1 Street Address is required.';
            }

            if (!data.ref1City) {
                errors.ref1City =
                    'Reference 1 City is required.';
            }

            if (!data.ref1State) {
                errors.ref1State =
                    'Reference 1 State / Province is required.';
            }

            if (!data.ref2CompanyName) {
                errors.ref2CompanyName =
                    'Reference 2 Company Name is required.';
            }

            if (!data.ref2ContactName) {
                errors.ref2ContactName =
                    'Reference 2 Contact Name is required.';
            }

            if (!data.ref2Phone) {
                errors.ref2Phone =
                    'Reference 2 Phone Number is required.';
            }

            if (!data.ref2Addr1) {
                errors.ref2Addr1 =
                    'Reference 2 Street Address is required.';
            }

            if (!data.ref2City) {
                errors.ref2City =
                    'Reference 2 City is required.';
            }

            if (!data.ref2State) {
                errors.ref2State =
                    'Reference 2 State / Province is required.';
            }

            if (!data.agreeTerms1) {
                errors.agreeTerms1 =
                    'You must agree to the 30-day payment terms.';
            }

            if (!data.agreeTerms2) {
                errors.agreeTerms2 =
                    'You must agree to the 7-day claim policy.';
            }

            if (!data.agreeTerms3) {
                errors.agreeTerms3 =
                    'You must accept the terms & conditions.';
            }

            if (!data.termsSignature) {
                errors.termsSignature =
                    'Agreed and Accepted Signature is required. Please draw your signature.';
            }

            if (!data.applicationDate) {
                errors.applicationDate =
                    "Today's Date is required.";
            }

            return errors;
        },

        saveForm: function (e) {
            e.preventDefault();

            if (this.isSubmitting) {
                return;
            }

            var self = this;

            this.$(
                '.credit-application-error-text'
            ).text('');

            this.errorMessage = '';

            /*
             * Read both signature pads FIRST.
             */
            var authSignature =
                this.getSignatureData(
                    this.authSignaturePad,
                    '#authSignature'
                );

            var termsSignature =
                this.getSignatureData(
                    this.termsSignaturePad,
                    '#termsSignature'
                );

            /*
             * Keep hidden fields synchronized too.
             */
            this.$('#authSignature').val(
                authSignature
            );

            this.$('#termsSignature').val(
                termsSignature
            );

            var formData = {
                companyName:
                    $.trim(
                        this.$('#companyName').val()
                    ),

                phoneNumber:
                    $.trim(
                        this.$('#phoneNumber').val()
                    ),

                faxNumber:
                    $.trim(
                        this.$('#faxNumber').val()
                    ),

                email:
                    $.trim(
                        this.$('#email').val()
                    ),

                shipAddr1:
                    $.trim(
                        this.$('#shipAddr1').val()
                    ),

                shipAddr2:
                    $.trim(
                        this.$('#shipAddr2').val()
                    ),

                shipCity:
                    $.trim(
                        this.$('#shipCity').val()
                    ),

                shipState:
                    $.trim(
                        this.$('#shipState').val()
                    ),

                shipPostal:
                    $.trim(
                        this.$('#shipPostal').val()
                    ),

                shipCountry:
                    $.trim(
                        this.$('#shipCountry').val()
                    ),

                companyType:
                    this.$(
                        'input[name="companyType"]:checked'
                    ).val() || '',

                apFirstName:
                    $.trim(
                        this.$('#apFirstName').val()
                    ),

                apLastName:
                    $.trim(
                        this.$('#apLastName').val()
                    ),

                apPhone:
                    $.trim(
                        this.$('#apPhone').val()
                    ),

                apFax:
                    $.trim(
                        this.$('#apFax').val()
                    ),

                apEmail:
                    $.trim(
                        this.$('#apEmail').val()
                    ),

                billAddr1:
                    $.trim(
                        this.$('#billAddr1').val()
                    ),

                billAddr2:
                    $.trim(
                        this.$('#billAddr2').val()
                    ),

                billCity:
                    $.trim(
                        this.$('#billCity').val()
                    ),

                billState:
                    $.trim(
                        this.$('#billState').val()
                    ),

                billPostal:
                    $.trim(
                        this.$('#billPostal').val()
                    ),

                billCountry:
                    $.trim(
                        this.$('#billCountry').val()
                    ),

                bankName:
                    $.trim(
                        this.$('#bankName').val()
                    ),

                bankBranchName:
                    $.trim(
                        this.$('#bankBranchName').val()
                    ),

                bankBranchContact:
                    $.trim(
                        this.$('#bankBranchContact').val()
                    ),

                bankPhone:
                    $.trim(
                        this.$('#bankPhone').val()
                    ),

                bankAddr1:
                    $.trim(
                        this.$('#bankAddr1').val()
                    ),

                bankAddr2:
                    $.trim(
                        this.$('#bankAddr2').val()
                    ),

                bankCity:
                    $.trim(
                        this.$('#bankCity').val()
                    ),

                bankState:
                    $.trim(
                        this.$('#bankState').val()
                    ),

                bankPostal:
                    $.trim(
                        this.$('#bankPostal').val()
                    ),

                bankCountry:
                    $.trim(
                        this.$('#bankCountry').val()
                    ),

                fedTaxId:
                    $.trim(
                        this.$('#fedTaxId').val()
                    ),

                dunsNumber:
                    $.trim(
                        this.$('#dunsNumber').val()
                    ),

                creditRequested:
                    $.trim(
                        this.$('#creditRequested').val()
                    ),

                poRequired:
                    this.$(
                        'input[name="poRequired"]:checked'
                    ).val() || '',

                checkingAcctNum:
                    $.trim(
                        this.$('#checkingAcctNum').val()
                    ),

                checkingRoutingNum:
                    $.trim(
                        this.$('#checkingRoutingNum').val()
                    ),

                savingsAcctNum:
                    $.trim(
                        this.$('#savingsAcctNum').val()
                    ),

                savingsRoutingNum:
                    $.trim(
                        this.$('#savingsRoutingNum').val()
                    ),

                authReleaseInfo:
                    this.$(
                        '#authReleaseInfo'
                    ).is(':checked'),

                /*
                 * Both signatures explicitly included.
                 */
                authSignature:
                    authSignature,

                termsSignature:
                    termsSignature,

                ref1CompanyName:
                    $.trim(
                        this.$('#ref1CompanyName').val()
                    ),

                ref1ContactName:
                    $.trim(
                        this.$('#ref1ContactName').val()
                    ),

                ref1AccountType:
                    $.trim(
                        this.$('#ref1AccountType').val()
                    ),

                ref1Phone:
                    $.trim(
                        this.$('#ref1Phone').val()
                    ),

                ref1Fax:
                    $.trim(
                        this.$('#ref1Fax').val()
                    ),

                ref1Email:
                    $.trim(
                        this.$('#ref1Email').val()
                    ),

                ref1Addr1:
                    $.trim(
                        this.$('#ref1Addr1').val()
                    ),

                ref1Addr2:
                    $.trim(
                        this.$('#ref1Addr2').val()
                    ),

                ref1City:
                    $.trim(
                        this.$('#ref1City').val()
                    ),

                ref1State:
                    $.trim(
                        this.$('#ref1State').val()
                    ),

                ref1Postal:
                    $.trim(
                        this.$('#ref1Postal').val()
                    ),

                ref1Country:
                    $.trim(
                        this.$('#ref1Country').val()
                    ),

                ref2CompanyName:
                    $.trim(
                        this.$('#ref2CompanyName').val()
                    ),

                ref2ContactName:
                    $.trim(
                        this.$('#ref2ContactName').val()
                    ),

                ref2AccountType:
                    $.trim(
                        this.$('#ref2AccountType').val()
                    ),

                ref2Phone:
                    $.trim(
                        this.$('#ref2Phone').val()
                    ),

                ref2Fax:
                    $.trim(
                        this.$('#ref2Fax').val()
                    ),

                ref2Email:
                    $.trim(
                        this.$('#ref2Email').val()
                    ),

                ref2Addr1:
                    $.trim(
                        this.$('#ref2Addr1').val()
                    ),

                ref2Addr2:
                    $.trim(
                        this.$('#ref2Addr2').val()
                    ),

                ref2City:
                    $.trim(
                        this.$('#ref2City').val()
                    ),

                ref2State:
                    $.trim(
                        this.$('#ref2State').val()
                    ),

                ref2Postal:
                    $.trim(
                        this.$('#ref2Postal').val()
                    ),

                ref2Country:
                    $.trim(
                        this.$('#ref2Country').val()
                    ),

                agreeTerms1:
                    this.$(
                        '#agreeTerms1'
                    ).is(':checked'),

                agreeTerms2:
                    this.$(
                        '#agreeTerms2'
                    ).is(':checked'),

                agreeTerms3:
                    this.$(
                        '#agreeTerms3'
                    ).is(':checked'),

                applicationDate:
                    $.trim(
                        this.$('#applicationDate').val()
                    )
            };

            if (window.console) {
                console.log(
                    'Credit Application signature diagnostics:',
                    {
                        authSignaturePresent:
                            !!formData.authSignature,

                        authSignatureLength:
                            formData.authSignature ?
                                formData.authSignature.length :
                                0,

                        termsSignaturePresent:
                            !!formData.termsSignature,

                        termsSignatureLength:
                            formData.termsSignature ?
                                formData.termsSignature.length :
                                0
                    }
                );
            }

            var errors =
                this.validateClientForm(
                    formData
                );

            if (!_.isEmpty(errors)) {
                _.each(
                    errors,
                    function (msg, field) {
                        self.$(
                            '[data-validation-error="' +
                            field +
                            '"]'
                        ).text(msg);
                    }
                );

                var $firstError =
                    this.$(
                        '.credit-application-error-text:not(:empty)'
                    ).first();

                if ($firstError.length) {
                    $('html, body').animate(
                        {
                            scrollTop:
                                $firstError.offset().top -
                                120
                        },
                        400
                    );
                }

                return;
            }

            this.isSubmitting = true;

            /*
             * Do not render here before model.save().
             * Rendering recreates both canvas elements.
             */
            this.$(
                'button[type="submit"], input[type="submit"]'
            ).prop(
                'disabled',
                true
            );

            this.model.save(
                formData,
                {
                    success: function (
                        model,
                        response
                    ) {
                        self.isSubmitting = false;

                        if (
                            response &&
                            response.success
                        ) {
                            var newRecId =
                                response.recordId ||
                                response.internalid ||
                                '1584';

                            self.showSuccess = true;
                            self.recordId =
                                newRecId;

                            self.render();

                            $('html, body').animate(
                                {
                                    scrollTop: 0
                                },
                                400
                            );
                        } else {
                            self.errorMessage =
                                (
                                    response &&
                                    response.error
                                ) ?
                                    response.error :
                                    'An unexpected error occurred while saving your application. Please try again.';

                            self.render();
                        }
                    },

                    error: function (
                        model,
                        jqXHR
                    ) {
                        self.isSubmitting = false;

                        var errObj;

                        try {
                            errObj =
                                JSON.parse(
                                    jqXHR.responseText
                                );
                        } catch (e) {
                        }

                        self.errorMessage =
                            (
                                errObj &&
                                errObj.error
                            ) ?
                                errObj.error :
                                'Failed to communicate with NetSuite server. Please check your connection and try again.';

                        self.render();
                    }
                }
            );
        },

        getCountriesList: function () {
            return [
                {
                    code: 'United States',
                    name: 'United States',
                    isSelected: true
                },
                {
                    code: 'Canada',
                    name: 'Canada'
                },
                {
                    code: 'United Kingdom',
                    name: 'United Kingdom'
                },
                {
                    code: 'Australia',
                    name: 'Australia'
                },
                {
                    code: 'Mexico',
                    name: 'Mexico'
                },
                {
                    code: 'Germany',
                    name: 'Germany'
                },
                {
                    code: 'France',
                    name: 'France'
                },
                {
                    code: 'Japan',
                    name: 'Japan'
                },
                {
                    code: 'Other',
                    name: 'Other'
                }
            ];
        },

        getTodayDateString: function () {
            var today = new Date();

            var yyyy =
                today.getFullYear();

            var mm =
                String(
                    today.getMonth() + 1
                ).padStart(
                    2,
                    '0'
                );

            var dd =
                String(
                    today.getDate()
                ).padStart(
                    2,
                    '0'
                );

            return (
                yyyy +
                '-' +
                mm +
                '-' +
                dd
            );
        },

        getContext: function () {
            return {
                model:
                    this.model.toJSON(),

                countries:
                    this.getCountriesList(),

                todayDate:
                    this.getTodayDateString(),

                isSubmitting:
                    this.isSubmitting,

                showSuccess:
                    this.showSuccess,

                errorMessage:
                    this.errorMessage,

                recordId:
                    this.recordId
            };
        }
    });
});
